import * as React from 'react';
import { IsLoggedIn } from '@grandvisionhq/auth';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import 'throttle-debounce';
import '@swc/helpers';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import '../../types.js';
import '@grandvisionhq/fun-store-filters';
import useGetPreferredStore from '../../hooks/api/use-get-preferred-store.js';
import '../../operations/mutations/update-personal-details.js';
import '@grandvisionhq/locations';
import '@grandvisionhq/utils';
import 'lodash/deburr';
import '../../context/StoreFinderSlots/context.js';
import PreferredStoreTile from '../PreferredStoreTile/PreferredStoreTile.js';
import HighlightPrefferedStore from './HighlightPreferredStore.js';

const HighlightPreferredStoreContainer = ()=>{
    const { getLabel  } = useIntl();
    const { setPreferredStore  } = useStoreFinderContext();
    const { data: store  } = useGetPreferredStore();
    const title = getLabel('stores.component.storeFinder.preferredStoreTile.title');
    React.useEffect(()=>{
        if (store) {
            setPreferredStore(store);
        }
    }, [
        store,
        setPreferredStore
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightPrefferedStore, {
        title: title
    }, /*#__PURE__*/ React.createElement(PreferredStoreTile, {
        store: store
    }));
};
var HighlightPreferredStoreContainer$1 = (()=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(HighlightPreferredStoreContainer, null))
);

export { HighlightPreferredStoreContainer$1 as default };
//# sourceMappingURL=HighlightPreferredStoreContainer.js.map
